import { Injectable } from '@angular/core';
import { Router, NavigationEnd, NavigationStart, Event } from '@angular/router';
import { Observable } from 'rxjs';
import { debounceTime, filter, map, pairwise, startWith, tap } from 'rxjs/operators';
import { RouterNavigationEndEvent } from '@anecdotes/user-event-data-access';

/** A router wrapper, adding extra functions. */
@Injectable()
export class RouterExtensionService {
  private startPageUrl: string;

  constructor(private router: Router) {}

  routerNavigationEndEvent$: Observable<RouterNavigationEndEvent> = this.router.events.pipe(
    tap((event: Event) => {
      if (event instanceof NavigationStart) {
        this.startPageUrl = this.removeUrlParameters(this.router.url);
      }
    }),
    filter((event) => event instanceof NavigationEnd),
    map((event) => event as NavigationEnd),
    debounceTime(1000), // prevents frequent emmisions that usually happen during redirections
    startWith({} as NavigationEnd),
    pairwise(),
    filter(([prevNavigationEnd, currentNavigationEnd]) => {
      const previousUrl = this.removeUrlParameters(prevNavigationEnd.urlAfterRedirects);
      const currentUrl = this.removeUrlParameters(currentNavigationEnd.urlAfterRedirects);

      return previousUrl !== currentUrl;
    }),
    map(([prevNavigationEnd, currentNavigationEnd]) => {
      const previousUrl = this.removeUrlParameters(prevNavigationEnd.urlAfterRedirects) || this.startPageUrl;
      const currentUrl = this.removeUrlParameters(currentNavigationEnd.urlAfterRedirects);

      return { currentEvent: currentNavigationEnd, currentUrl, previousUrl };
    })
  );

  private removeUrlParameters(url: string): string {
    return url?.split('?')[0] || '';
  }
}
